import { useTranslation } from 'react-i18next';
import {
  FormControlInput,
  FormControlSelect,
} from '../../../../app/components/FormControls';
import { IconBriefcase, IconClock, IconCoin } from '../../../../app/components/Icons';
import { LESSON_CURRENCIES, type LessonOfferingDraft } from '../../application/types';

const FIELD_WIDTH = '100%';
const FIELD_HEIGHT = 40;

type Props = {
  value: LessonOfferingDraft;
  onChange: (next: LessonOfferingDraft) => void;
};

const DURATION_MINUTES = ['30', '45', '60'] as const;

const currencyOptions = LESSON_CURRENCIES.map((currency) => ({
  value: currency,
  label: currency,
}));

function durationOptions(current: string) {
  const values = DURATION_MINUTES.includes(current as (typeof DURATION_MINUTES)[number])
    ? [...DURATION_MINUTES]
    : [current, ...DURATION_MINUTES];
  return values.filter(Boolean).map((minutes) => ({
    value: minutes,
    label: `${minutes}m`,
  }));
}

export function LessonForm({ value, onChange }: Props) {
  const { t } = useTranslation();

  const setCurrency = (currency: string | number | null) => {
    onChange({
      ...value,
      currency: (currency == null ? 'UAH' : String(currency)) as LessonOfferingDraft['currency'],
    });
  };

  return (
    <div className="mentor-lessons__form">
      <FormControlInput
        name="title"
        label={t('lesson.title_lesson')}
        placeholder={t('lesson.title_placeholder')}
        value={value.title}
        maxLength={255}
        width={FIELD_WIDTH}
        height={FIELD_HEIGHT}
        className="form-field"
        isRequired
        leftIcon={<IconBriefcase />}
        onChange={(title) => onChange({ ...value, title })}
      />
      <FormControlSelect
        name="durationMinutes"
        label="lesson.duration_label"
        value={value.durationMinutes}
        options={durationOptions(value.durationMinutes)}
        className="form-field"
        style={{ width: FIELD_WIDTH }}
        isRequired
        leftIcon={<IconClock />}
        onChange={(durationMinutes) =>
          onChange({
            ...value,
            durationMinutes: durationMinutes == null ? '60' : String(durationMinutes),
          })
        }
      />
      <div className="mentor-lessons__price-row">
        <FormControlInput
          name="price"
          type="number"
          label={t('lesson.price')}
          value={value.price}
          min={0}
          width={FIELD_WIDTH}
          height={FIELD_HEIGHT}
          className="form-field"
          isRequired
          leftIcon={<IconCoin />}
          onChange={(price) => onChange({ ...value, price })}
        />
        <FormControlSelect
          name="currencyCompact"
          value={value.currency}
          options={currencyOptions}
          className="form-field"
          style={{ width: '120px' }}
          onChange={setCurrency}
        />
      </div>
    </div>
  );
}
